import { render, staticRenderFns } from "./_publicDialog.vue?vue&type=template&id=c2a74d8e"
import script from "./_publicDialog.vue?vue&type=script&lang=js"
export * from "./_publicDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports